export enum SpecialOpsCode {
	BANNER_HP = "BANNER_HP",
	CANAL_HOME = "CANAL_HOME",
	CLASSIQUE_HOME = "CLASSIQUE_HOME",
	CLUB300 = "CLUB300",
	DISNEY_HOME = "DISNEY_HOME",
	DOLBY_HOME = "DOLBY_HOME",
	EMERGENCE = "EMERGENCE",
	EMERGENCE_MOVIE = "EMERGENCE_MOVIE",
	EMERGENCE_SERIES = "EMERGENCE_SERIES",
	EMERGENCE_SVOD = "EMERGENCE_SVOD",
	FESTIVAL_SECTION = "FESTIVAL_SECTION",
	FILMES_ONLINE = "FILMES_ONLINE",
	IMAX_HOME = "IMAX_HOME",
	INDELEBILE_HOME = "INDELEBILE_HOME",
	M6_HOME = "M6_HOME",
	MAX_HOME = "MAX_HOME",
	MOBILE_DDAY = "MOBILE_DDAY",
	NOVELAS_HOME = "NOVELAS_HOME",
	ROLLER_HOME = "ROLLER_HOME",
	SPONSORED_AUTOCOMPLETE = "SPONSORED_AUTOCOMPLETE",
	TF1_HOME = "TF1_HOME",
	TICKET_ANCHOR = "TICKET_ANCHOR",
	VOD_HOME = "VOD_HOME",
}

const SPECIAL_OPS_CODES: ReadonlySet<string> = new Set(Object.values(SpecialOpsCode))

// Narrows a stored code (a plain text column) to a known SpecialOpsCode.
export const isSpecialOpsCode = (code: string): code is SpecialOpsCode => SPECIAL_OPS_CODES.has(code)

// Reads a comma-separated list of codes, e.g. "EMERGENCE_MOVIE,EMERGENCE_SERIES".
export const parseSpecialOpsCodes = (value: string | undefined) =>
	(value ?? "")
		.split(",")
		.map((code) => code.trim())
		.filter((code) => code.length > 0)
		.map((code) => {
			if (!isSpecialOpsCode(code)) throw new Error(`Unknown special operation code "${code}"`)
			return code
		})

export enum TicketAnchorSlot {
	HOMEPAGE = "anchor_t_o_discovery_hp",
	MOVIE_CARD = "anchor_t_o_discovery_movie_card",
	MOVIE_CARD_THEATER_PAGE = "anchor_t_o_discovery_movie_card_theaterpage",
	NEWS = "anchor_t_o_discovery_news",
	PERSON_PAGE = "anchor_t_o_discovery_personpage",
	SHOWTIMES = "anchor_t_o_discovery_showtimes",
	THEATER_PAGE = "anchor_t_o_discovery_theaterpage",
}

// Where an EMERGENCE_MOVIE film is released; the website picks the logo from it.
export enum EmergenceDistribution {
	STREAMING = "STREAMING",
	THEATER = "THEATER",
}

// Rejects a per-code map type that misses a code, so a new SpecialOpsCode member fails to compile until it is listed.
export type EverySpecialOpsCode<TByCode extends { [TCode in SpecialOpsCode]: unknown }> = TByCode
